import React from 'react';
import { BiData, LiveNotificationCancelBiEvent } from '@wix/da-bi/pkg/events';
import CloseButton from '../../../Button/CloseButton';
import { ThemeOverride, useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';

import s from './LiveNotificationCard.scss';

interface Props {
  onClose(): void;
  onMouseEnter(): void;
  onMouseLeave(): void;
  biData: {
    notification_type: string;
    notification_sender_id: string;
    typeid: number;
    itemid: number;
  };
}

const LiveNotificationCard: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  onClose,
  onMouseEnter,
  onMouseLeave,
  biData,
}) => {
  const reverseTheme = useReverseTheme();
  return (
    <ThemeOverride theme={reverseTheme}>
      <div className={s['root']} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className={s['content']}>{children}</div>
        <CloseButton
          className={s['close-btn']}
          onClick={onClose}
          biData={BiData<LiveNotificationCancelBiEvent>({
            evid: 655,
            ...biData,
          })}
        />
      </div>
    </ThemeOverride>
  );
};

LiveNotificationCard.displayName = 'LiveNotificationCard';

export default LiveNotificationCard;
